import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/api/client";
import { validateResponse } from "@/api/validateResponse";
import { PackageListResponseSchema, type Package } from "@/api/types/package";

/** Packages rarely change (seeded once) — cache generously. */
export function usePackages() {
  return useQuery<Package[]>({
    queryKey: ["packages", "list"],
    queryFn: async () => {
      const { data } = await apiClient.get("/v2/packages");
      return validateResponse(
        PackageListResponseSchema,
        data,
        "GET /v2/packages",
      ).items;
    },
    staleTime: 5 * 60 * 1000,
  });
}
